/*! tbs-copy-pin 2026-08-22 */
(function () {
  function lang() {
    var path = (location.pathname || '').toLowerCase();
    if (path === '/nl' || path.indexOf('/nl/') === 0) return 'nl';
    try {
      if (window.Weglot && typeof Weglot.getCurrentLang === 'function') return Weglot.getCurrentLang();
    } catch (e) {}
    var m = document.cookie.match(/(?:^|; )wglang=([^;]+)/);
    return m ? decodeURIComponent(m[1]) : 'en';
  }

  var TITLE_MAP = {
    'how-to-use-solid-titanium-pan': {
      en: 'How to Use a Solid Titanium Pan',
      nl: 'Zo gebruik je een pan van gelagerd titanium',
      tagNl: 'Koken & onderhoud'
    },
    'chefs-pan-size-guide-small-medium-large': {
      en: "Chef's Pan Size Guide: Small vs Medium vs Large",
      nl: "Maatwijzer Chef's Pan: Small, Medium of Large",
      tagNl: "Chef's Pan"
    },
    'titanium-vs-ceramic-vs-stainless-vs-cast-iron': {
      en: 'Titanium vs Ceramic vs Stainless vs Cast Iron',
      nl: 'Titanium vs keramiek, roestvrij staal en gietijzer',
      tagNl: 'Vergelijking'
    },
    'why-solid-titanium-beats-coated-non-stick': {
      en: 'Why Solid Titanium Beats Coated Non-Stick',
      nl: 'Waarom gelagerd titanium beter is dan antiaanbak',
      tagNl: 'Kookgerei'
    }
  };

  function handleFromHref(href) {
    var m = (href || '').match(/\/blogs\/[^/]+\/([^/?#]+)/i);
    return m ? decodeURIComponent(m[1]).toLowerCase() : '';
  }

  function apply() {
    var nl = lang() === 'nl';
    var map = [
      ['Guides that earn a bookmark', nl ? 'Gidsen voor koken op titanium' : 'Guides for cooking on titanium'],
      ['Gidsen die een bladwijzer verdienen', 'Gidsen voor koken op titanium'],
      ['Guides for cooking on titanium', nl ? 'Gidsen voor koken op titanium' : 'Guides for cooking on titanium']
    ];
    document.querySelectorAll('h2.tbs-title, .tbs-title').forEach(function (el) {
      var t = (el.textContent || '').trim();
      for (var i = 0; i < map.length; i++) {
        if (t === map[i][0]) {
          el.textContent = map[i][1];
          break;
        }
      }
    });
    document.querySelectorAll('.tbs-eyebrow').forEach(function (el) {
      var t = (el.textContent || '').trim();
      if (t === 'Kitchen notes' || t === 'Keukentips' || t === 'KEUKENTIPS') {
        el.textContent = nl ? 'Keukentips' : 'Kitchen notes';
      }
    });
    document.querySelectorAll('a.tbs-all').forEach(function (el) {
      var label = nl ? 'Alles bekijken' : 'View all';
      el.textContent = label + ' →';
    });
    document.querySelectorAll('.tbs-foot a,[data-en][data-nl]').forEach(function (el) {
      if (!el.getAttribute('data-nl')) return;
      var next = nl ? el.getAttribute('data-nl') : el.getAttribute('data-en');
      if (next) el.textContent = next;
    });
    document.querySelectorAll('.tbs-card').forEach(function (card) {
      var handle = handleFromHref(card.getAttribute('href') || '');
      var pin = TITLE_MAP[handle];
      var titleEl = card.querySelector('.tbs-card__title');
      var byEl = card.querySelector('.tbs-card__by');
      var tagEl = card.querySelector('.tbs-card__meta span:last-child');
      var dateEl = card.querySelector('[data-tbs-date]');
      if (titleEl) {
        if (pin) {
          titleEl.setAttribute('data-en', pin.en);
          titleEl.setAttribute('data-nl', pin.nl);
        }
        var tNext = nl ? titleEl.getAttribute('data-nl') : titleEl.getAttribute('data-en');
        if (tNext) titleEl.textContent = tNext;
      }
      if (byEl) {
        byEl.textContent = nl ? 'Door Titanoré Labs' : 'By Titanoré Labs';
      }
      if (tagEl && pin && pin.tagNl) {
        tagEl.textContent = nl ? pin.tagNl : tagEl.getAttribute('data-en') || tagEl.textContent;
      }
      if (dateEl && nl) {
        var iso = dateEl.getAttribute('data-tbs-date');
        if (iso) {
          var d = new Date(iso + 'T12:00:00');
          if (!isNaN(d.getTime())) {
            dateEl.textContent = d.toLocaleDateString('nl-NL', { day: 'numeric', month: 'short', year: 'numeric' });
          }
        }
      }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply);
  else apply();
  setTimeout(apply, 50);
  setTimeout(apply, 400);
  setTimeout(apply, 1200);
  try {
    if (window.Weglot && typeof Weglot.on === 'function') Weglot.on('languageChanged', apply);
  } catch (e) {}
})();
